import { render, staticRenderFns } from "./CaracteristicaAspectoGerais.vue?vue&type=template&id=777d5540"
import script from "./CaracteristicaAspectoGerais.vue?vue&type=script&lang=js"
export * from "./CaracteristicaAspectoGerais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports